import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-delete",
  "use": "icon-delete-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"icon-delete\">\n<path id=\"icon-delete_形状\" d=\"M129.6,215.5l679.8,679.8c23.5,23.5,61.5,23.5,85,0c23.5-23.5,23.5-61.5,0-85L214.6,130.4\n\tc-23.5-23.5-61.5-23.5-85,0S106.1,192,129.6,215.5z M809.4,130.4L129.6,810.3c-23.5,23.5-23.5,61.5,0,85c23.5,23.5,61.5,23.5,85,0\n\tl679.8-679.8c23.5-23.5,23.5-61.5,0-85C870.9,107,832.9,107,809.4,130.4z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol